import { useMutation } from '@tanstack/react-query';

import { customerApi } from 'api/customer';

export function useSubmitPrivacyRequestCsvMutation() {
    return useMutation({
        mutationFn: (file) => customerApi.submitPrivacyRequestCsv(file),
    });
}
